import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {WebviewUtils} from '@shared/webviewUtils';

export interface VehicleDetailBottomSheetProps {
  vin: string;
}

function VehicleDetailBottomSheet({vin}: VehicleDetailBottomSheetProps) {
  const {t} = useInferableTranslation();

  function linkToVehicleDeletePage(vin: string) {
    WebviewUtils.openNewWebView({
      url: `${import.meta.env.VITE_CCI_DOMAIN}/my/cars/${vin}/delete`,
      isModal: true,
      isNavigationBar: true,
      isToolBar: false,
    });
  }

  return (
    <div className="bottom_sheet delete_vehicle">
      <div className="bottom_sheet_header">
        <h2 className="bottom_sheet_title">{t('T20343')}</h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('T10017')}
          onClick={() => window.bottomSheetClose(false)}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <strong className="bottom_sheet_title_sub">{t('T20344')}</strong>
          <div className="bottom_sheet_container">
            <strong className="bottom_sheet_title">{t('T20345')}</strong>
            <ul className="bottom_sheet_list">
              <p className="bottom_sheet_item">{t('T20346')}</p>
              <p className="bottom_sheet_item">{t('T20347')}</p>
            </ul>
          </div>
        </div>

        <div className="bottom_sheet_footer bottom_sheet_footer_complex">
          <button
            type="button"
            className="btn btn_large btn_outline"
            onClick={() => window.bottomSheetClose(false)}
          >
            {t('T20119')}
          </button>

          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={() => linkToVehicleDeletePage(vin)}
          >
            {t('T20348')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default VehicleDetailBottomSheet;
